import React from "react";
import { FaQuoteRight } from "react-icons/fa";

const Testimonial = () => {
  const testimonials = [
    {
      id: 1,
      name: "Ankit Gurjar",
      position: "Founder & CEO, Pool Home Care",
      image: "/images/home/testimonials/ankit.jpg",
      content: "As the owner of Pool Home Care, I can confidently say that our clients are thrilled with the transformation of their pools. Our team ensures professional and timely service, and we are proud to exceed expectations every time. Highly recommended!",
      },
  ];
  return (
    <div className="pt-20">
      <div className="text-center">
        <h1 className="mx-auto sub-heading">Testimonials</h1>
        <h1 className="heading">What they're saying about our work</h1>
      </div>
      <div className="flex-center-center max-w-[600px] w-[90%] h-[500px] md:h-[350px] mx-auto relative overflow-hidden">
        {testimonials.map(({ id, name, position, image, content }) => (
          <div
            key={id}
            className=" w-full text-center h-full p-6 transition absolute opacity-100"
          >
          <div className="relative group">
              <img
                src={image}
                alt={name}
                className="object-cover w-28 h-28 mx-auto border-2 border-orange-500 rounded-full shadow-xl transform group-hover:scale-110 transition-transform duration-500 ease-in-out"
              />
            </div>
            <div className="px-10 info">
              <h1 className="mt-4 uppercase text-md font-bold">{name}</h1>
              <p className="text-sm capitalize text-primary">{position}</p>
              <p className="mt-2 italic">"{content}"</p>
              <div className="flex-center-center">
                <FaQuoteRight className="absolute text-primary/10 text-8xl" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
